<template>
  <div>
    <md-table v-model="requestList" :table-header-color="tableHeaderColor">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Finder Name">{{ item.user == null ? 'Unknown' : item.user.name  }}</md-table-cell>
        <md-table-cell md-label="Finder Phone">{{ item.user == null ? 'Unknown' : item.user.phone_number }}</md-table-cell>
        <md-table-cell md-label="Donor Name">{{ item.donor.name }}</md-table-cell>
        <md-table-cell md-label="Donor Phone">{{ item.donor.phone_number }}</md-table-cell>
        <md-table-cell md-label="Blood Group">{{ item.donor.blood_group.blood_group }}</md-table-cell>
        <md-table-cell md-label="Location">{{ item.search_place }}</md-table-cell>
        <md-table-cell md-label="Request Date">{{ item.created_at.date }}</md-table-cell>
        <md-table-cell md-label="Status"><button class="status"><span>{{ item.request_status.request_status }}</span></button></md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
  var moment = require('moment');
  export default {
    name: 'simple-table',
    props: {
      tableHeaderColor: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        selected: [],
        requestList:[]
      }
    },
    beforeMount: function () {
      this.$store.dispatch('GetRequestList').then((response)=> {
        console.log('RequestList', response);
        this.requestList = response.data.data;
        this.requestList.forEach((request)=>{
          request.created_at.date = moment(request.created_at.date).format('YYYY-MM-DD');

        })
      })
    }
  }
</script>
<style>
  .status {
    border-radius: 4px;
    background-color: orange;
    width: auto;
    padding: 5px;
    border: none;
    color: #FFFFFF;
    text-align: center;
    font-size: 12px;
    transition: all 0.5s;
    cursor: pointer;
    text-transform: none !important;
    margin-left: -20%;
  }


</style>
